<template>
  <div class="ai-platform-page hero-style-home">
    <div class="ai-hero-banner">
      <img
        src="@/assets/jiejue/custom/industry-gov-cloud-hero-banner.svg"
        alt=""
        style="width: 100%"
        class="top_img"
        @load="loaded = true"
        :class="{ show: loaded }"
      />
      <div class="ai-hero-title">{{ solutionHeroTitle }}</div>
    </div>

    <nav class="product-tabs-bar">
      <a class="product-tab" :class="{ active: activeTab === 'background' }" href="#background" @click.prevent="scrollTo('background')">需求背景</a>
      <a class="product-tab" :class="{ active: activeTab === 'challenges' }" href="#challenges" @click.prevent="scrollTo('challenges')">业务挑战</a>
      <a class="product-tab" :class="{ active: activeTab === 'scenarios' }" href="#scenarios" @click.prevent="scrollTo('scenarios')">场景应用</a>
      <a v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM" class="product-tab" :class="{ active: activeTab === 'architecture' }" href="#architecture" @click.prevent="scrollTo('architecture')">部署示意图</a>
      <a class="product-tab" :class="{ active: activeTab === 'advantages' }" href="#advantages" @click.prevent="scrollTo('advantages')">方案优势</a>
      <a class="product-tab" :class="{ active: activeTab === 'cases' }" href="#cases" @click.prevent="scrollTo('cases')">典型案例</a>
    </nav>

    <div class="product-body">
    <section id="background" class="product-section section-row ai-platform-block" :class="{ 'animate-in': backgroundVisible }">
      <div class="section-title">需求背景</div>
      <div class="section-content">
        <div class="background-card">
          <p class="case-text case-text-full">
            {{ backgroundIntroLead }}{{ backgroundIntroConnector }}基于云安全资源池构建集安全能力、资源调度、合规监管于一体的云安全解决方案，为政务业务提供统一、弹性、可管可控的集约化安全防护与合规保障服务。
          </p>
        </div>
      </div>
    </section>

    <section id="challenges" class="product-section section-row ai-platform-block" :class="{ 'animate-in': challengesVisible }">
      <div class="section-title">业务挑战</div>
      <div class="section-content">
        <div class="grid-2">
          <div class="card">
            <img class="card-icon" src="@/assets/jiejue/sase/1.svg" alt="icon" />
            <div class="card-text">
              <div class="card-title">多租户隔离与数据安全风险突出</div>
              <div class="card-desc">
                政务云平台承载多个区县、多个部门的云租户，各租户业务系统、数据资源共享云基础设施，若隔离措施不到位，易出现跨租户越权访问、数据泄露等问题，且政务数据涵盖个人信息、政务秘密等敏感内容，全流程安全防护难度大。
              </div>
            </div>
          </div>
          <div class="card">
            <img class="card-icon" src="@/assets/jiejue/sase/2.svg" alt="icon" />
            <div class="card-text">
              <div class="card-title">安全防护体系不完善</div>
              <div class="card-desc">
                部分政务云仅部署基础边界防护设备，缺乏主机、应用、数据等全环节防护能力，难以抵御SQL注入、勒索病毒、恶意爬虫等新型网络攻击；同时安全设备分散部署，缺乏协同联动，无法形成纵深防御体系，安全威胁处置效率低。
              </div>
            </div>
          </div>
          <div class="card">
            <img class="card-icon" src="@/assets/jiejue/sase/3.svg" alt="icon" />
            <div class="card-text">
              <div class="card-title">合规要求高且整改难度大</div>
              <div class="card-desc">
                政务云及承载的业务系统需严格遵循《网络安全法》《数据安全法》《个人信息保护法》，同时需满足网络安全等级保护三级（及以上）、政务数据安全管理等相关要求，现有安全架构与合规标准存在差距，且多租户场景下，合规管控与审计难度大。
              </div>
            </div>
          </div>
          <div class="card">
            <img class="card-icon" src="@/assets/jiejue/sase/4.svg" alt="icon" />
            <div class="card-text">
              <div class="card-title">运维管理效率低且协同不足</div>
              <div class="card-desc">
                政务云涉及多个部门、多种安全设备，缺乏统一的安全管控平台，安全日志、威胁信息无法集中汇总分析，安全态势不可视；同时部门间安全职责划分不清晰，应急响应协同不畅，难以快速处置突发安全事件。
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="scenarios" class="product-section section-row ai-platform-block" :class="{ 'animate-in': scenariosVisible }">
      <div class="section-title">场景应用</div>
      <div class="section-content">
        <div class="scenarios">
          <div class="scenario-text">
            <div class="scenario-item">
              <div class="item-title">政务服务场景</div>
              <div class="item-desc">
                适配政务服务一体化平台，覆盖社保、医保、户籍、不动产登记等高频政务服务业务，承载公众办事数据、企业登记数据等敏感信息，需保障业务系统稳定运行、数据传输安全，同时满足个人信息保护合规要求，防范数据泄露与滥用。
              </div>
            </div>
            <div class="scenario-item highlight">
              <div class="item-title">公共资源与敏感政务场景</div>
              <div class="item-desc">
                适配公共资源交易平台、政务秘密管理系统等，涉及招投标数据、政务秘密信息等核心敏感内容，需具备高强度安全防护能力，实现数据加密存储、访问权限精细化管控、操作全程可审计，满足等保三级及以上合规要求，防范高级别网络攻击。
              </div>
            </div>
          </div>
          <img
            src="@/assets/jiejue/zwy/right.png"
            alt=""
            style="width: 50%; border-radius: 4px;"
            class="mobile-hidden-img"
          >
        </div>
      </div>
    </section>

    <section v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM" id="architecture" class="product-section section-row ai-platform-block" :class="{ 'animate-in': architectureVisible }">
      <div class="section-title">部署示意图</div>
      <div class="section-content">
      <img src="@/assets/solutions/deploy/industry-gov-cloud.svg" alt="部署示意图" class="architecture-image">
      </div>
    </section>

    <section id="advantages" class="product-section section-row advantages ai-platform-block" :class="{ 'animate-in': advantagesVisible }">
      <div class="section-title">方案优势</div>
      <div class="section-content">
        <div class="grid-4">
          <div class="adv-card">
            <img src="@/assets/jiejue/1.svg" alt="" class="adv-badge" />
            <div class="adv-title">全流程纵深防护，保障政务安全</div>
            <div class="adv-desc">
              构建“边界-云内-数据-管控”四层纵深防御体系，覆盖政务云全场景、全环节，可有效抵御外部攻击、内部违规等各类安全风险，同时实现多租户安全隔离，防范跨租户数据泄露，保障政务业务系统稳定运行与敏感数据安全。
            </div>
          </div>
          <div class="adv-card">
            <img src="@/assets/jiejue/2.svg" alt="" class="adv-badge" />
            <div class="adv-title">合规适配性强，降低整改成本</div>
            <div class="adv-desc">
              方案严格遵循政务领域相关法规与等保三级（及以上）标准，内置合规管控模块，可快速补全安全短板，自动生成合规审计报表，助力政务云及各租户业务系统顺利通过等保测评、数据安全合规检查，大幅降低合规整改周期与成本。
            </div>
          </div>
          <div class="adv-card">
            <img src="@/assets/jiejue/3.svg" alt="" class="adv-badge" />
            <div class="adv-title">集约化管控，提升运维效率</div>
            <div class="adv-desc">
              通过统一安全管控平台，实现所有安全设备、安全事件的集中管理，可视化展示安全态势，支持安全策略统一下发、故障远程处置，大幅减少运维人员工作量；同时实现跨部门安全协同，明确安全职责，提升应急响应效率，适配政务云多部门协同运维需求。
            </div>
          </div>
          <div class="adv-card">
            <img src="@/assets/jiejue/4.svg" alt="" class="adv-badge" />
            <div class="adv-title">灵活可扩展，适配业务增长</div>
            <div class="adv-desc">
              方案采用模块化、虚拟化设计，可根据政务云租户数量、业务规模的增长，灵活扩容安全资源、新增安全模块；支持与政务云现有基础设施、业务系统无缝对接，无需大规模改造，适配政务数字化转型过程中的业务拓展需求，具备长期可用性。
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="cases" class="product-section section-row ai-platform-block" :class="{ 'animate-in': casesVisible }">
      <div class="section-title">典型案例</div>
      <div class="section-content section-content-cases">
        <div class="case-content case-content-blink">
          <div class="case-section">
            <h3 class="case-subtitle">需求背景</h3>
            <p class="case-text">
              某省信息中心按照“集约高效、共享开放、安全可靠、按需服务”的原则，构建省级电子政务云平台，实现市政府各部门基础设施共建共用、数据资源汇聚共享、业务应用有效协同。该政务云平台覆盖政务外网、互联网两大区域，承载着420个云租户的业务系统，涉及政务服务、公共资源交易、城市治理等多个核心领域，需按照网络安全等级保护三级标准进行建设。当前，政务云平台面临的核心安全挑战是：租户数量多、业务场景复杂，需实现租户间的安全隔离，防止数据泄露；政务数据量大、敏感信息多，需保障数据传输、存储、使用全流程安全；安全设备分散，缺乏统一的安全管控和态势感知能力，难以快速发现和处置安全威胁；需满足等保三级合规要求，支撑政务云平台的安全稳定运行。为此，该省信息中心引入政务云安全解决方案，构建全方位的政务云安全防护体系。
            </p>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">用户痛点</h3>
            <ul class="case-list">
              <li>1. 租户隔离与数据安全保障难：420个云租户共享政务云资源，需实现租户间的物理隔离和逻辑隔离，防止跨租户数据泄露，同时保障政务敏感数据的全流程安全；</li>
              <li>2. 安全防护体系不完整：政务云涵盖外网、互联网两大区域，需实现边界防护、主机防护、应用防护、安全审计等全流程防护，现有安全能力存在短板；</li>
              <li>3. 安全态势感知能力弱：缺乏统一的安全态势展示和分析平台，无法实时掌握政务云整体安全状态，安全威胁发现不及时、处置效率低；</li>
              <li>4. 合规要求高：需严格按照等保三级标准建设，同时满足政务数据安全、个人信息保护等相关法规要求，合规整改难度大。</li>
            </ul>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">解决方案</h3>
            <ul class="case-list">
              <li>1. 构建租户隔离与数据安全体系：采用虚拟化分布式防火墙技术，实现各租户间的逻辑隔离，同时部署数据加密、数据脱敏等安全组件，对政务敏感数据进行全流程加密保护，确保数据“可用不可见”；严格控制租户访问权限，采用最小权限原则，防止跨租户越权访问。</li>
              <li>2. 搭建全方位纵深防御体系：在政务外网区域部署云数据库审计系统、集中日志审计系统、应用安全审计系统；在互联网区域部署云堡垒机、云数据库审计系统和网页访问监控系统；同时部署虚拟化WEB应用防火墙、入侵检测与防护、下一代防火墙、防病毒等安全产品，实现从边界、主机、应用到审计的全流程防护。</li>
              <li>3. 强化安全态势感知与处置：搭建统一的安全态势大屏，集中采集政务云平台所有安全设备的日志、流量数据，采用大数据引擎进行集中挖掘、关联分析及追踪溯源，实时展示安全威胁态势，实现安全威胁的快速发现、告警和处置；建立安全应急响应机制，确保突发安全事件能够及时处置，保障业务连续性。</li>
              <li>4. 满足合规要求：按照等保三级标准优化安全架构，完善身份鉴别、访问控制、安全审计、软件容错等功能，补全安全短板；定期开展等保自评和漏洞扫描，及时整改安全隐患，生成合规审计报表，确保政务云平台及租户业务系统顺利通过等保三级测评，满足政务数据安全合规要求。</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    </div>

    
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { SHOW_SOLUTION_DEPLOY_DIAGRAM } from '@/data/solutionUi.js'
const route = useRoute()

/** 「解决方案（新）」入口 /solutions/industry-government-cloud-security 与 /solutions/zwy 共用本页，文案按路由区分 */
const isIndustryGovernmentCloudPage = computed(() => route.path === '/solutions/industry-government-cloud-security')

const solutionHeroTitle = computed(() =>
  isIndustryGovernmentCloudPage.value ? '行业云/政务云安全解决方案' : '政务云安全解决方案'
)

/** 方案简介首段冒号前主语：新入口为「行业云/政务云安全解决方案」，原路径仍为「政务云安全解决方案」 */
const backgroundIntroLead = computed(() =>
  isIndustryGovernmentCloudPage.value ? '行业云/政务云安全解决方案' : '政务云安全解决方案'
)

/** 行业云/政务云入口：冒号改为「是」；原 /solutions/zwy 路径仍用冒号 */
const backgroundIntroConnector = computed(() =>
  isIndustryGovernmentCloudPage.value ? '是' : ':'
)

const loaded = ref(false)
const backgroundVisible = ref(false)
const challengesVisible = ref(false)
const scenariosVisible = ref(false)
const architectureVisible = ref(false)
const advantagesVisible = ref(false)
const casesVisible = ref(false)

const activeTab = ref('background')
const scrollTo = (id) => {
  const el = document.getElementById(id)
  if (!el) return
  
  // 立即设置activeTab，确保点击时立即高亮
  activeTab.value = id
  history.replaceState(null, '', `#${id}`)
  
  // 设置标志，表示这是程序触发的滚动
  isScrollingProgrammatically.value = true
  
  // 滚动到目标元素
  if (el.scrollIntoView) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  } else {
    const stickyOffset = 120
    const y = el.getBoundingClientRect().top + window.scrollY - stickyOffset
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
  
  // 滚动完成后重置标志，允许IntersectionObserver再次更新activeTab
  setTimeout(() => {
    isScrollingProgrammatically.value = false
  }, 1000) // 延迟约1秒
}

// 动画与导航观察器
const animationObserver = ref(null)
const navObserver = ref(null)
const navTimeout = ref(null)
const isScrollingProgrammatically = ref(false) // 防止程序滚动时覆盖activeTab

// 检查元素是否在视口内
const checkElementVisibility = (element) => {
  const rect = element.getBoundingClientRect()
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight
  // 元素与视口有交叉即视为可见
  return rect.top < viewportHeight && rect.bottom > 0
}

// 观察所有区块
const observeBlocks = () => {
  const ids = ['background', 'challenges', 'scenarios', 'architecture', 'advantages', 'cases']
  
  // 动画观察器 - 控制 animate-in
  const animationObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id
          if (id === 'background') backgroundVisible.value = true
          if (id === 'challenges') challengesVisible.value = true
          if (id === 'scenarios') scenariosVisible.value = true
          if (id === 'architecture') architectureVisible.value = true
          if (id === 'advantages') advantagesVisible.value = true
          if (id === 'cases') casesVisible.value = true
        }
      })
    },
    { root: null, threshold: 0.1, rootMargin: '-10% 0px -10% 0px' }
  )
  
  // 导航观察器 - 根据滚动更新 activeTab
  const navigationObserver = new IntersectionObserver(
    (entries) => {
      // 若是程序触发的滚动，不在此处更新 activeTab
      if (isScrollingProgrammatically.value) return
      
      const visible = entries.filter((e) => e.isIntersecting)
      if (!visible.length) return
      visible.sort((a, b) => b.intersectionRatio - a.intersectionRatio)
      const id = visible[0].target.id
      if (id && activeTab.value !== id) {
        activeTab.value = id
        history.replaceState(null, '', `#${id}`)
      }
    },
    {
      root: null,
      threshold: [0.25, 0.5, 0.75],
      rootMargin: '-80px 0px -50% 0px',
    }
  )
  
  // 为每个区块添加观察
  ids.forEach((id) => {
    const el = document.getElementById(id)
    if (el && el.classList.contains('ai-platform-block')) {
      // 若已在视口内则先显示
      if (checkElementVisibility(el)) {
        if (id === 'background') backgroundVisible.value = true
        if (id === 'challenges') challengesVisible.value = true
        if (id === 'scenarios') scenariosVisible.value = true
        if (id === 'architecture') architectureVisible.value = true
        if (id === 'advantages') advantagesVisible.value = true
        if (id === 'cases') casesVisible.value = true
      }
      // 开始观察
      animationObserver.observe(el)
      navigationObserver.observe(el)
    }
  })
  
  animationObserver.value = animationObserver
  navObserver.value = navigationObserver
}

onMounted(async () => {
  // 刷新页面时清除 URL 中的 hash，并重置 activeTab
  if (location.hash) {
    history.replaceState(null, '', location.pathname)
    activeTab.value = 'background'
  }
  
  // 等待 DOM 完全渲染后再设置观察器
  await nextTick()
  observeBlocks()
})

onBeforeUnmount(() => { 
  if (animationObserver.value) animationObserver.value.disconnect()
  if (navObserver.value) navObserver.value.disconnect()
  if (navTimeout.value) clearTimeout(navTimeout.value)
})
</script>

<style scoped>
@import '../../assets/css/solution-page.css';

.ai-hero-banner {
  position: relative;
  overflow: hidden;
}

.ai-hero-title {
  position: absolute;
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  font-size: 48px;
  color: var(--color-text);
  font-weight: 600;
  letter-spacing: 0.01em;
  text-shadow: 0 8px 24px rgba(255, 255, 255, 0.6);
  z-index: 2;
  pointer-events: none;
  white-space: nowrap;
}

.ai-platform-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: var(--color-text);
}

/* section-row / section-title / section-content 使用 solution-page.css（product-page）的左右分栏与 padding */
.ai-platform-block { opacity: 0; transform: translateY(30px); transition: opacity 0.6s ease, transform 0.6s ease; }
.ai-platform-block.animate-in { opacity: 1; transform: translateY(0); }
.background-card { width: 100%; box-sizing: border-box; background: #fff; border-radius: 8px; padding: 36px 40px; box-shadow: 0 2px 12px rgba(0,0,0,0.08); border: 1px solid #e8e8e8; }
.background-card:hover { box-shadow: 0 8px 24px rgba(0,0,0,0.12); }
.case-content { max-width: 100%; margin: 0 auto; text-align: left; }
.section-content-cases { text-align: left; }
.case-content-blink { padding: 24px; border-radius: 8px; animation: case-blink 2.5s ease-in-out infinite; }
@keyframes case-blink { 0%,100%{opacity:1;box-shadow:0 0 0 rgba(6,85,159,0)} 50%{opacity:.88;box-shadow:0 0 28px rgba(6,85,159,0.25)} }
.case-section + .case-section { margin-top: 32px; }
.case-subtitle { font-size: 20px; font-weight: 600; color: #06559f; margin-bottom: 12px; }
.case-text { font-size: 14px; line-height: 1.8; color: #333; }
.case-text-full { font-size: 16px; line-height: 1.9; text-align: left; }
.case-list { font-size: 14px; line-height: 1.8; color: #333; padding-left: 0; list-style: none; }
@media (max-width: 1200px) { .mobile-hidden-img { display: none } }

.hero {
  position: relative;
  height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(110deg, #eaf2ff 0%, #f7fbff 40%, #eef5ff 60%, #dfeaff 100%);
  overflow: hidden;
}

.hero::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(1200px 360px at 75% 20%, rgba(24,144,255,0.18) 0%, rgba(24,144,255,0) 60%),
              radial-gradient(800px 300px at 20% 80%, rgba(64,158,255,0.20) 0%, rgba(64,158,255,0) 60%);
}

.hero-inner {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  padding: 0 24px;
  text-align: left;
}

.hero-inner h1 {
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 18px;
  color: #0f172a;
}

.hero-inner p {
  font-size: 16px;
  line-height: 1.7;
  color: #333;
}

.block { 
      scroll-margin-top: 120px;
    max-width: 1420px;
    margin: 0 auto;
    padding: 60px 20px 90px 20px;
 }

.grid-2 { display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; }
.grid-4 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }

.card {
  display: flex;
  align-items: flex-start;
  gap: 17px;
  background:  #F5F7FA;;
  /* border: 1px solid #E6EBF5; */
  /* box-shadow: 0px 3px 6px 0px #EBEFF7; */
  border-radius: 6px;
  padding: 30px 30px;
  min-height: 173px;
  box-sizing: border-box;
}

.card-icon { flex-shrink: 0; }
.card-text { display: flex; flex-direction: column;text-align: start; }
.card-title { 
  font-family: PingFang SC;
font-size: 18px;
font-weight: 600;
line-height: normal;
letter-spacing: 0em;

font-variation-settings: "opsz" auto;
color: #000000;
line-height: 40px;
 }
.card-desc { font-size: 14px; line-height: 1.7; color: #666; }

.scenarios {
  display: flex;
  /* grid-template-columns: minmax(0, 1fr) 629px; */
  /* gap: 0; */
  align-items: stretch;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.scenario-text {
  background: #fff;
  border-radius: 4px;
  /* box-shadow: 0px 3px 6px 0px #EBEFF7; */
  padding: 50px 50px 0px 40px;
  /* height: 369px; */
  box-sizing: border-box;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  text-align: start;
}

.scenario-item { margin-bottom: 18px; }
.scenario-item .item-title { font-size: 16px; line-height: 16px; color: #333; margin-bottom: 8px;font-family: PingFang SC; }
.scenario-item .item-desc { font-size: 14px; line-height: 1.8; color: #666; }
/* .scenario-item.highlight .item-title { color: #FF6A00; } */

.scenario-image {
  background-image: url('@/assets/jiejue/ai-tiaozhan/1.jpg');
  background-size: cover;
  background-position: center;
  border-radius: 6px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 629px;
  height: 369px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.scenario-image::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 40%;
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.85) 40%, rgba(255,255,255,0) 100%);
  pointer-events: none;
}

.diagram { display: grid; gap: 12px; }
.layer { background: #fff; border: 1px solid #e6ebf5; border-radius: 6px; }
.layer-title { padding: 10px 14px; font-size: 14px; color: #333; background: #f6f9ff; border-color: #dfe8ff; }
.layer-title.blue { background: #e8f2ff; border-color: #cfe0ff; }
.grid.layer-app { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; padding: 12px; }
.grid.layer-ml { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 12px; }
.grid.layer-data { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 12px; }
.grid.layer-infra { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 12px; }
.grid.layer-app > div,
.grid.layer-ml > div,
.grid.layer-data > div,
.grid.layer-infra > div { background: #f9fbff; border: 1px dashed #e1e9ff; border-radius: 6px; padding: 12px; text-align: center; font-size: 13px; }

@media (max-width: 1200px) {
  .grid-2 { grid-template-columns: 1fr; }
  .grid-4 { grid-template-columns: repeat(2, 1fr); }
  .scenarios { grid-template-columns: 1fr; }
}

@media (max-width: 768px) {
  .hero { height: 280px; }
  .hero-inner h1 { font-size: 28px; line-height: 28px; }
  .block { padding: 56px 5%; }
  .grid-2 { grid-template-columns: 1fr; }
  .grid-4 { grid-template-columns: 1fr; }
  .section-nav { top: 56px; gap: 16px; height: 48px; }
  .section-nav a { font-size: 13px; }
  .grid.layer-ml,
  .grid.layer-data,
  .grid.layer-infra { grid-template-columns: repeat(2, 1fr); }
  .scenario-image { width: 100%; height: 280px; }
  .scenario-text { height: auto; border-radius: 6px; }
}

.fade-enter-active, .fade-leave-active { transition: opacity .25s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
#advantages { background: linear-gradient(180deg, #F5F7FA 0%, #E0ECFF 100%);max-width: unset; }
.advantages .grid-4 { display: grid; grid-template-columns: repeat(4, 1fr); align-items: stretch; gap: 16px; max-width: 100%; margin: 0 auto; }
.advantages .adv-card { min-width: 0; }
.adv-card { min-height:240px;position: relative; background: #fff;  border-radius: 4px;  padding: 29px; padding-top: 70px; display: flex; flex-direction: column; box-sizing: border-box; text-align: start; }
.adv-badge { position: absolute; top: 33px; left: 29px; width: 24px; height: 24px; border-radius: 4px; background: #1890FF; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 600; }
.adv-title { font-size: 18px; font-family: PingFang SC; color: #333; margin-bottom: 10px; font-weight: 600; }
.adv-desc { font-size: 14px; line-height: 1.6; color: #333; }
.main-content{
  background: #fff;
}
#scenarios{
  max-width: unset;
  background: #F5F7FA;

  /* max-width: 1182px; */
}
</style>


